import { render, staticRenderFns } from "./data-cattle-slaughter.vue?vue&type=template&id=5791da60&scoped=true"
import script from "./data-cattle-slaughter.vue?vue&type=script&lang=js"
export * from "./data-cattle-slaughter.vue?vue&type=script&lang=js"
import style0 from "./data-cattle-slaughter.vue?vue&type=style&index=0&id=5791da60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5791da60",
  null
  
)

export default component.exports